
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-info-dialog",
    templateUrl: "./info-dialog.component.html",
    styleUrls: ["./info-dialog.component.scss"],
})
export class InfoDialogComponent implements OnInit {
    isAttachmentOpen:boolean = false;
    constructor(
        public dialogRef: MatDialogRef<InfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        this.dialogRef.close(this.data.columnDefs);
    }


    isLink(value: any): boolean {
        return typeof value === 'string' && value.startsWith('http');
    }

    hasAttachments() {
        return Object.values(this.data.content)
            .some((v: any) => this.isLink(v));
    }


    openFile(link: any) {
        //need to add link from api once dd api data is coming
        console.log(link)
        this.isAttachmentOpen=true;
    }
}